import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Actions from '@panneau/action-actions';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import { useActions } from '@panneau/core/hooks';

var styles = {};

var _excluded = ["item", "value", "placeholder", "actions", "urlGenerator", "actionsProps", "size", "theme", "outline", "className", "buttonsClassName"],
  _excluded2 = ["urlGenerator"];
var propTypes = {
  item: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })]).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  actions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
  urlGenerator: PropTypes.func,
  actionsProps: PropTypes.shape({}),
  size: PropTypes$1.buttonSize,
  theme: PropTypes.string,
  outline: PropTypes.bool,
  className: PropTypes.string,
  buttonsClassName: PropTypes.string
};
var defaultProps = {
  value: null,
  placeholder: null,
  actions: ['show', 'edit', 'delete'],
  urlGenerator: null,
  actionsProps: null,
  size: 'sm',
  theme: null,
  outline: null,
  className: null,
  buttonsClassName: null
};
var ActionsDisplay = function ActionsDisplay(_ref) {
  var item = _ref.item;
    _ref.value;
    _ref.placeholder;
    var actions = _ref.actions,
    parentUrlGenerator = _ref.urlGenerator,
    actionsProps = _ref.actionsProps,
    size = _ref.size,
    theme = _ref.theme,
    outline = _ref.outline,
    className = _ref.className,
    buttonsClassName = _ref.buttonsClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = actionsProps || {},
    urlGenerator = _ref2.urlGenerator,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  var finalActions = useActions(item, actions, parentUrlGenerator || urlGenerator, otherProps);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement(Actions, Object.assign({}, props, {
    className: buttonsClassName,
    actions: finalActions,
    item: item,
    size: size,
    theme: theme,
    outline: outline,
    value: [item],
    isGroup: true
  })));
};
ActionsDisplay.propTypes = propTypes;
ActionsDisplay.defaultProps = defaultProps;

export { ActionsDisplay as default };
